var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"live"},[_c('div',{class:_vm.drawPanel ? 'livePlayer':'drawPanel',on:{"click":_vm.drawPanelCLikc}},[_c('div',{attrs:{"id":"playbackPlayer"}})]),_vm._v(" "),_c('div',{class:!_vm.drawPanel ? 'livePlayer':'drawPanel',on:{"click":_vm.drawPanelCLikc}},[_c('div',{attrs:{"id":"playbackPanel"}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c10451f","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/videoLayer/playback/playback.vue
// module id = null
// module chunks = 